(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('TimeseriesData', TimeseriesData);

    TimeseriesData.$inject = ['$resource', 'DateUtils'];

    function TimeseriesData ($resource, DateUtils) {
        var resourceUrl =  'api/timeseries-data/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
